export enum QuestionFormTypes {
    Text = 'text',
    ControlName = 'control_name',
    ControlGroup = 'control_group',
    ControlNumber = 'control_number',
    QuestionType = 'question_type',
    IRN = 'irn',
    ControlDependencies = 'control_dependencies',
    DependsOn = 'depends_on'
}